import gql from "graphql-tag";

export const MY_HR_COMPANIES_SUBSCRIPTION = gql`
  subscription companiesSubscription {
    companiesSubscription
  }
`;
